import VirtualPath from "meta/utils/virtualPath";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
// This list contains errors that we don't want to log to our API
// because we're not able to fix them and they overwhelm our logs
const ignoredErrors = ["ResizeObserver loop limit exceeded"];
const shouldIgnoreError = (error) => {
    const includesIgnoredError = ignoredErrors.some((ignored) => error.message.includes(ignored));
    return includesIgnoredError;
};
export default function (error) {
    if (shouldIgnoreError(error)) {
        console.warn("Ignoring client error: ", error);
        return;
    }
    setTimeout(() => {
        let xhr = new XMLHttpRequest();
        xhr.open("POST", `${VirtualPath}/webapi/log`);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.setRequestHeader("X-CSRF-Token", getRootAppWindow(window).JSON_PARAMS.CsrfToken);
        let errorPayload = {
            path: `${window.name}|${window.location.pathname}`,
            message: error.message,
            file: error.filename,
            line: error.lineno,
            col: error.colno,
            error: error.error,
        };
        // Load and separate error message and stack trace if provided
        if (error.error instanceof Error) {
            let messageDelimiter = error.error.message.indexOf("\r\nWeb page:");
            errorPayload.error = messageDelimiter >= 0 ? error.error.message.substring(0, messageDelimiter) : error.error.message;
            errorPayload.message = error.error.stack || '';
        }
        xhr.send(JSON.stringify(errorPayload));
    }, 500);
}
